<template>
    <view-card headline="고객정보" :disabled="disabled">
        <v-col slot="buttons" v-if="!disabled" cols="auto" class="py-0">
            <v-row justify="end">
                <v-col class="py-0">
                    <v-btn small color="secondary" @click="set">고객정보와 동일</v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-row>
            <v-col cols="4" class="pt-0">
                <v-text-field v-model="value.name" label="성명" placeholder=" " hide-details />
            </v-col>
            <v-col cols="4" class="pt-0">
                <v-text-field v-model="value.birthDate" type="date" label="생년월일" placeholder=" " hide-details />
            </v-col>
            <v-col cols="4" class="pt-0">
                <v-text-field v-model="value.phone" label="인증연락처" placeholder=" " hide-details />
            </v-col>
        </v-row>
        <v-text-field v-model="value.address" label="시공지주소" placeholder=" " hide-details />
    </view-card>
</template>
<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard, VDateField },
    props: {
        value: {
            name: { type: String, default: null },
            birthDate: { type: Date, default: null },
            phone: { type: String, default: null }, // 전자인증용 연락처
            address: { type: String, default: null }, // 시공지 주소
        },
        employer: {
            name: { type: String, default: null },
            phone: { type: String, default: null },
            address: { type: String, default: null }, // 시공지 주소
        },
        disabled: { type: Boolean, default: true },
    },

    methods: {
        set() {
            this.$emit("input", { ...this.employer });
        },
    },
};
</script>
